import { render, staticRenderFns } from "./UpdateUAMProfileBottomSheet.vue?vue&type=template&id=e8eb7450&scoped=true"
import script from "./UpdateUAMProfileBottomSheet.vue?vue&type=script&lang=js"
export * from "./UpdateUAMProfileBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./UpdateUAMProfileBottomSheet.vue?vue&type=style&index=0&id=e8eb7450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eb7450",
  null
  
)

export default component.exports